import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Voters from './components/Voters';
/**
 * Adds our custom {@link Voters} component to the discussion sidebar.
 */
export default function addVotersToDiscussionPageSideBar() {
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    var _firstPost$canSeeVote, _firstPost$seeVoters;
    const discussion = this.discussion;
    const posts = discussion.posts() || [];
    const firstPost = posts == null ? void 0 : posts[0];
    if (firstPost != null && (_firstPost$canSeeVote = firstPost.canSeeVotes) != null && _firstPost$canSeeVote.call(firstPost) && firstPost != null && (_firstPost$seeVoters = firstPost.seeVoters) != null && _firstPost$seeVoters.call(firstPost) && !!app.forum.attribute('fof-gamification.firstPostOnly')) {
      items.add('op-voters', m(Voters, {
        post: firstPost
      }), 90);
    }
  });
}